const updateDomainGym = (state, { payload: { workouts } }) => {
	state.workouts = workouts;
};

export default updateDomainGym;
